import React from 'react';
import { Box, Button } from '@material-ui/core';
import { jsPDF } from "jspdf";
import * as globalService from '../../../../../../services/GlobalService';

const LOGO_PNG_OUS = {
    'UNID': 'https://point-files.s3.us-west-2.amazonaws.com/public/logos_png/boleta_UNID.png',
    'UERRE': 'https://point-files.s3.us-west-2.amazonaws.com/public/logos_png/boleta_UERRE.png'
};

const DownloadGradesButton = ({companyId, reportGrades}) => {

    if(!companyId){
        return null;
    }

    const handleClickDownloadGradesFile = async () => {
        try {
            const blobAsBase64Logo = await globalService.downloadFile(LOGO_PNG_OUS[companyId]);

            const pdf = new jsPDF({
                unit: 'pt',
                format: 'letter',
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 40;
            const contentWidth = pageWidth - (margin * 2);
            const bottomMargin = 40;

            // ===== HEADER =====
            const headerHeight = 60;

            // Logo como header completo
            pdf.addImage(`data:image/png;base64,${blobAsBase64Logo}`, 'PNG', 0, 0, pageWidth, headerHeight);

            // ===== DATOS DEL ALUMNO =====
            let y = headerHeight + 30;

            const col1X = margin;
            const col1LabelW = 60;
            const col1ValueW = 270;
            const col2X = margin + col1LabelW + col1ValueW + 12;
            const col2LabelW = 95;
            const col2ValueW = contentWidth - col1LabelW - col1ValueW - 12 - col2LabelW;

            // Calcular un tamaño de fuente uniforme para todos los valores
            const fieldValues = [
                { value: reportGrades.person.name, width: col1ValueW },
                { value: reportGrades.program.levelName, width: col2ValueW },
                { value: reportGrades.program.name, width: col1ValueW },
                { value: reportGrades.program.programCode, width: col2ValueW },
            ];

            pdf.setFont('helvetica', 'normal');
            let valueFontSize = 8;
            const fitsAll = () => {
                pdf.setFontSize(valueFontSize);
                return fieldValues.every(f => {
                    const text = f.value ? f.value.toUpperCase() : '';
                    return pdf.getTextWidth(text) <= (f.width - 12);
                });
            };
            while (!fitsAll() && valueFontSize > 5) {
                valueFontSize -= 0.5;
            }

            const drawField = (label, value, x, yPos, labelWidth, valueWidth) => {
                // Label
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(9);
                pdf.setTextColor(0, 0, 0);
                pdf.text(label, x, yPos);

                // Value box
                pdf.setFillColor(241, 241, 241); // #F1F1F1
                const boxX = x + labelWidth;
                const boxY = yPos - 10;
                const boxH = 16;
                pdf.rect(boxX, boxY, valueWidth, boxH, 'F');

                // Value text (uniform font size)
                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(valueFontSize);
                const displayValue = value ? value.toUpperCase() : '';
                pdf.text(displayValue, boxX + 6, yPos);
            };

            // Fila 1: Alumno + Nivel académico
            drawField('Alumno:', reportGrades.person.name, col1X, y, col1LabelW, col1ValueW);
            drawField('Nivel académico:', reportGrades.program.levelName, col2X, y, col2LabelW, col2ValueW);

            y += 26;

            // Fila 2: Programa + Clave de programa
            drawField('Programa:', reportGrades.program.name, col1X, y, col1LabelW, col1ValueW);
            drawField('Clave de programa:', reportGrades.program.programCode, col2X, y, col2LabelW, col2ValueW);

            // ===== TABLA DE CALIFICACIONES =====
            y += 36;

            const cellGap = 4;
            const claveColW = 70;
            const optColW = 34;
            const dateColW = 75;
            const nameColW = contentWidth - claveColW - (optColW * 3) - dateColW;
            const colWidths = [claveColW, nameColW, optColW, optColW, optColW, dateColW];
            const colX = [];
            let currentX = margin;
            for (let i = 0; i < colWidths.length; i++) {
                colX.push(currentX);
                currentX += colWidths[i];
            }

            // Función reutilizable para dibujar el encabezado de la tabla.
            // Devuelve la posición Y justo debajo del encabezado.
            const drawTableHeader = (startY) => {
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(7);
                pdf.setTextColor(0, 0, 0);

                const row1Y = startY;        // primera línea de headers
                const row2Y = startY + 10;   // segunda línea (Opt 1, 2, 3)
                const centerY = startY + 5;  // centro vertical para headers de una sola línea

                // Clave (centrada en su columna)
                pdf.text('Clave', colX[0] + colWidths[0] / 2, centerY, { align: 'center' });
                // Nombre de materia (centrada en su columna)
                pdf.text('Nombre de materia', colX[1] + colWidths[1] / 2, centerY, { align: 'center' });
                // Calificaciones (colspan 3) - fila superior
                const calCenter = colX[2] + (colWidths[2] + colWidths[3] + colWidths[4]) / 2;
                pdf.text('Calificaciones', calCenter, row1Y, { align: 'center' });
                // Opt 1, 2, 3 - fila inferior, debajo de Calificaciones
                pdf.text('Opt 1', colX[2] + colWidths[2] / 2, row2Y, { align: 'center' });
                pdf.text('Opt 2', colX[3] + colWidths[3] / 2, row2Y, { align: 'center' });
                pdf.text('Opt 3', colX[4] + colWidths[4] / 2, row2Y, { align: 'center' });
                // Fecha de última oportunidad (dos líneas, centrado en su columna)
                const fechaCenter = colX[5] + colWidths[5] / 2;
                pdf.text('Fecha de última', fechaCenter, row1Y, { align: 'center' });
                pdf.text('oportunidad', fechaCenter, row2Y, { align: 'center' });

                // 16 (alto del header) + 4 (espacio antes de las filas)
                return startY + 16 + 4;
            };

            // Dibujar encabezado en la primera página
            y = drawTableHeader(y);

            // Filas de datos
            const courses = reportGrades.courses || [];
            const rowHeight = 20;

            courses.forEach((item) => {
                y += 4;

                // ===== SALTO DE PÁGINA AUTOMÁTICO =====
                // Si la fila no cabe en el espacio restante, crear página nueva
                // y repetir el encabezado de la tabla.
                if (y + rowHeight > pageHeight - bottomMargin) {
                    pdf.addPage();
                    y = margin;
                    y = drawTableHeader(y);
                    y += 4;
                }

                const textY = y + 8;

                pdf.setFont('helvetica', 'normal');
                pdf.setFontSize(8);
                pdf.setTextColor(0, 0, 0);

                // Dibujar cada celda como rectángulo gris individual
                for (let i = 0; i < colWidths.length; i++) {
                    pdf.setFillColor(241, 241, 241);
                    pdf.rect(colX[i] + cellGap / 2, y - 4, colWidths[i] - cellGap, rowHeight - 2, 'F');
                }

                // Clave (centrada)
                pdf.text(item.courseCode || '', colX[0] + colWidths[0] / 2, textY, { align: 'center' });
                // Nombre (alineado a la izquierda)
                const courseName = item.courseName || '';
                pdf.text(courseName, colX[1] + 4 + cellGap / 2, textY);
                // Opt 1
                pdf.text(item.gradeFirst != null ? String(item.gradeFirst) : '', colX[2] + colWidths[2] / 2, textY, { align: 'center' });
                // Opt 2
                pdf.text(item.gradeSecond != null ? String(item.gradeSecond) : '', colX[3] + colWidths[3] / 2, textY, { align: 'center' });
                // Opt 3
                pdf.text(item.gradeThird != null ? String(item.gradeThird) : '', colX[4] + colWidths[4] / 2, textY, { align: 'center' });
                // Fecha
                pdf.text(item.endDate || '', colX[5] + colWidths[5] / 2, textY, { align: 'center' });

                y += rowHeight;
            });

            // ===== NOTA =====
            y += 16;

            // Si la nota no cabe en lo que resta de la página, pasarla a una nueva.
            if (y + 30 > pageHeight - bottomMargin) {
                pdf.addPage();
                y = margin;
            }

            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(7);
            pdf.text('Nota: ', margin, y);

            const notaX = margin + pdf.getTextWidth('Nota: ');
            pdf.setFont('helvetica', 'normal');
            const notaTexto = companyId === 'UERRE'
                ? 'Las calificaciones se convierten de porcentaje a escala de 0 a 10 y se redondean conforme al Reglamento Institucional U-ERRE.'
                : 'Las calificaciones se convierten de porcentaje a escala de 0 a 10 y se redondean conforme al Reglamento General de Alumnos del Sistema UNID.';
            pdf.text(notaTexto, notaX, y, {
                maxWidth: contentWidth - pdf.getTextWidth('Nota: ')
            });

            pdf.save("Boleta de calificaciones.pdf");
        } catch(error) {
            console.log('error=>', error);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
            <Button variant='outlined' color='secondary' fullWidth onClick={handleClickDownloadGradesFile}>
                Descargar boleta de calificaciones
            </Button>
        </Box>
    );
};

export default DownloadGradesButton;
